import { HealthxchangeThemeFontSizes } from './typography';

/**
 * Dropdown menus only — scoped to MuiMenu so picker clock items, autocomplete
 * listbox rows, and sidebar MenuLinks are not affected by brand menu padding.
 */
export const menuListStyleOverrides = (theme: {
  palette: { silver: { main: string; light: string } };
}) => ({
  padding: 0,
  '& .MuiMenuItem-root': {
    fontFamily: 'Albert Sans',
    fontSize: HealthxchangeThemeFontSizes.desktop.m,
    padding: '1rem 1.5rem',
    '&.Mui-selected': {
      backgroundColor: theme.palette.silver.main,
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: theme.palette.silver.light,
      },
      '&.Mui-focusVisible': {
        backgroundColor: theme.palette.silver.main,
      },
    },
  },
});
